import axios from "axios";
import { API_URL } from "../config/app";
import { captureApiError } from "./api";

/**
 * Client delle pagine pubbliche (link presenze del cliente, disiscrizione dei
 * referenti). Niente token, niente azienda e niente modali del piano: chi
 * apre il link non ha un account. Gli errori restano registrati per il
 * pulsante "Invia report" del modale d'errore.
 */
const publicApi = axios.create({ baseURL: API_URL, timeout: 28000 });

publicApi.interceptors.response.use(
  (res) => res,
  (error) => {
    captureApiError(error);
    return Promise.reject(error);
  },
);

export default publicApi;
